import { LitElement, html, css, nothing, PropertyValues } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { addGlobalStylesToShadowRoot } from "../../util/globalStyleSheetsUtil";

@customElement("ehm-tab")
export class EhmTab extends LitElement {
  static styles = css`
    :host {
    }
  `;

  @property({ type: String }) label = "";
  @property({ type: String }) toggle = "";
  @property({ type: String }) tablistId = "";
  @property({ type: String }) class = "";
  @property({ type: String }) arialabel = "";
  @property({ type: String }) selected = "false";

  firstUpdated(_changedProperties: PropertyValues): void {
      super.firstUpdated(_changedProperties);
      addGlobalStylesToShadowRoot(this.shadowRoot!);
    }

  connectedCallback() {
    super.connectedCallback();
  }

  onClick(e: InputEvent) {
    e.preventDefault();
    const ehmTabs = this.closest(".tabs")?.querySelectorAll("ehm-tab");
    const tabs: HTMLElement[] = [];
    ehmTabs?.forEach((tab) => {
      tabs.push(tab.shadowRoot?.querySelector(".tab-item") as HTMLElement);
    })
    const tabPanes = document.querySelectorAll(".tab-pane") as NodeListOf<HTMLElement>;
    tabs?.forEach((tab : HTMLElement)=> {
      tab.classList.remove("active")
      tab.setAttribute("aria-selected", "false")
    });
    tabPanes?.forEach((tab : HTMLElement)=> {
      tab.classList.remove("active")
      tab.setAttribute("aria-selected", "false")

    });
    (e.target as HTMLButtonElement).classList.add("active");
    document.querySelector("#"+this.toggle)?.classList.add("active");
    (e.target as HTMLButtonElement).setAttribute("aria-selected", "true");
  }

  render() {
    return html`<a class="tab-item ${this.class}" role="tab" aria-label="${this.arialabel}" aria-selected="${this.selected === "true"}" href="#${this.toggle}" @click=${(e: InputEvent) => this.onClick(e)}>${this.label}</a>`
  }
}
